export const appendProtocol = (domain: string): string => {
  return `https://${domain.toLowerCase()}/`
}
